exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activity-title[data-v-5e108854]{font-size:24px;font-weight:700}", ""]);

// exports
